import { ID, IDPrefixes } from '@griply/types';
import { createPrefixId } from '@griply/utils';

import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type DeleteTagOptions<TDocRef = unknown, TDb = FirestoreInstance> = {
  tagId: ID;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  deleteDoc: (ref: NoInfer<TDocRef>) => Promise<void> | void;
  db: TDb;
};

export const deleteTag = async <TDocRef, TDb = FirestoreInstance>(
  options: DeleteTagOptions<TDocRef, TDb>,
): Promise<void> => {
  const { tagId, doc, deleteDoc, db } = options;

  const tagRef = doc(db, FirestoreCollections.Tags, tagId);
  const relationshipRef = doc(
    db,
    FirestoreCollections.Relationships,
    createPrefixId(tagId, IDPrefixes.Tag),
  );

  await Promise.all([deleteDoc(tagRef), deleteDoc(relationshipRef)]);
};
